// extracted by mini-css-extract-plugin
module.exports = {"banner":"KHYlp"};